import React, { useContext, useEffect, useState } from 'react';
import { Box, ButtonGroup } from '@chakra-ui/react';
import LinkButton from '../../../components/custom/LinkButton';
import AddCountryForm from '../../../components/forms/country/AddCountryForm';
import { useParams } from 'react-router-dom';
import { UseApi } from '../../../libraries/UseApi';
import { UserInfoContext } from '../../../provider/UserInfoProvider';
import { UseMessage } from '../../../libraries/UseMessage';
import Loading from '../../../components/common/Loading';
import PageHeader from '../../../components/common/PageHeader';

export default function EditCountry() {
    const { id } = useParams();
    const { getApi } = UseApi();
    const { token } = useContext(UserInfoContext);
    const { Message } = UseMessage();

    const [isProcessing, setIsProcessing] = useState(false);
    const [country, setCountry] = useState({});

    useEffect(() => {
        getCountry(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const getCountry = (id) => {
        // 処置中チェック
        if (isProcessing) {
            // 処理中の場合、以降の処理を実施しない
            return;
        }
        // 処理中フラグをONにする
        setIsProcessing(true);

        getApi(
            `${process.env.REACT_APP_API_URL}/country/${id}`, {}, { token: token },
            (response) => {
                // 成功時
                if (response.isSuccess === false) {
                    // error
                    alert(Message.Common.ERROR);
                    // 処理中フラグを元に戻す
                    setIsProcessing(false);
                    return;
                }

                setCountry(response.data);
                // 処理中フラグを元に戻す
                setIsProcessing(false);
            },
            () => {
                // 異常時
                // 処理中フラグをOFFにする
                setIsProcessing(false);
            }
        );
    }

    return (
        <>
            <div className='admin-page-header'>
                <PageHeader headerTitle={'国編集'} />
                <ButtonGroup gap={2}>
                    <LinkButton buttonText={'戻る'} buttonUrl={'/countries'} />
                </ButtonGroup>
            </div>
            <Box className='admin-box'>
                {isProcessing
                    ? <Loading />
                    : <AddCountryForm country={country} isEdit={true} />
                }
            </Box>
        </>
    )
}
